<template>
  <b-modal
    v-model="show"
    centered
    size="sm"
    ref="add-user-modal"
    header-bg-variant="primary"
    header-text-variant="white"
    no-close-on-backdrop
    header-class="bg-purple"
    @close="cancel"
  >
    <template v-slot:modal-footer="{}">
      <b-button variant="secondary" @click="cancel">
        Close
      </b-button>
      <b-button variant="primary" @click="addSupervisee">
        Save
      </b-button>
    </template>
    <template v-slot:modal-title>
      <h5 v-if="action == 'usersWithoutSupervisor'">User</h5>
      <h5 v-if="action == 'addSupervisee'">Add Supervisee</h5>
      <h5 v-if="action == 'changeSupervisor'">Change Supervisor</h5>
    </template>
    <b-form-group
      v-if="action == 'addSupervisee' || action == 'usersWithoutSupervisor'"
      :state="formErrors.users.length == 0 ? null : false"
      :invalid-feedback="formErrors.users.join(', ')"
    >
      <template v-slot:label>
        <b-row class="ml-2" v-if="action == 'usersWithoutSupervisor'"
          ><p>User:</p></b-row
        >
        <b-row class="ml-2" v-if="action == 'addSupervisee'"
          ><p>For User: {{ name }}</p></b-row
        >

        <b-row class="ml-2" v-if="action == 'addSupervisee'"
          ><p>Supervisee:</p></b-row
        >
      </template>
      <v-select :options="users" v-model="user"
    /></b-form-group>
    <b-form-group
      v-if="action == 'changeSupervisor'"
      :state="formErrors.supervisorOptions.length == 0 ? null : false"
      :invalid-feedback="formErrors.supervisorOptions.join(', ')"
    >
      <template v-slot:label>
        <b-row class="ml-2"
          ><p>For User: {{ name }}</p></b-row
        >
        <b-row class="ml-2"><p>Supervisor:</p></b-row>
      </template>
      <v-select :options="supervisorOptions" v-model="supervisor"
    /></b-form-group>
  </b-modal>
</template>
<script>
import supervisionServer from "../../server/supervision";
import { validateRequired } from "../../helpers/validation";

export default {
  name: "AddSuperviseeOrEditSupervisor",
  props: ["filter", "nameUser", "nameOrganization", "idOrganization"],
  data() {
    return {
      users: [],
      user: null,
      supervisorOptions: [],
      supervisor: null,
      name: this.nameUser,
      action: this.filter.filter,
      organization: null,
      form: {
        userId: this.filter.userId
      },
      formErrors: { users: [], supervisorOptions: [] }
    };
  },
  async mounted() {
    if (this.action == "usersWithoutSupervisor") await this.fetchUsers();

    if (this.action == "addSupervisee") await this.fetchSupervisee();

    if (this.action == "changeSupervisor") await this.fetchSupervisorOptions();
  },
  methods: {
    cancel() {
      this.clearErrors();
      this.$emit("addUserModalCancel");
    },
    async fetchUsers() {
      const result = await supervisionServer.getSupervisionChartUsers(
        this.filter
      );

      this.users = result.map(u => ({
        label: this.formatUser(u),
        value: u.id
      }));
    },
    async fetchSupervisee() {
      const result = await supervisionServer.getSupervisionChartUsers(
        this.filter
      );
      this.users = result.map(u => ({
        label: this.formatUser(u),
        value: u.id
      }));
    },
    async fetchSupervisorOptions() {
      const result = await supervisionServer.getSupervisionChartUsers(
        this.filter
      );
      this.supervisorOptions = result.map(u => ({
        label: this.formatUser(u),
        value: u.id,
        isOrganization: false
      }));
      this.supervisorOptions.push({
        label: this.nameOrganization,
        value: this.idOrganization,
        isOrganization: true
      });
    },
    validateSubmit() {
      let withoutErrors = true;
      if (this.action == "usersWithoutSupervisor") {
        this.formErrors.users = [];
        if (!validateRequired(this.user)) {
          this.formErrors.users.push("Must select a User");
          withoutErrors = false;
        }
      }
      if (this.action == "addSupervisee") {
        this.formErrors.users = [];
        if (!validateRequired(this.user)) {
          this.formErrors.users.push("Must select a supervisee");
          withoutErrors = false;
        }
      }
      if (this.action == "changeSupervisor") {
        this.formErrors.supervisorOptions = [];
        if (!validateRequired(this.supervisor)) {
          this.formErrors.supervisorOptions.push("Must select a supervisor");
          withoutErrors = false;
        }
      }

      return withoutErrors;
    },
    async addSupervisee() {
      const result = this.validateSubmit();
      if (result) {
        var formData = {};
        if (this.action == "usersWithoutSupervisor") {
          formData = { userId: this.user.value };
        }
        if (this.action == "addSupervisee") {
          formData = {
            supervisorUserId: this.form.userId,
            userId: this.user.value
          };
        }
        if (this.action == "changeSupervisor") {
          formData = {
            ...this.form,
            supervisorUserId: this.supervisor.isOrganization
              ? null
              : this.supervisor.value
          };
        }
        await supervisionServer.setSupervisor(formData);

        this.$emit("saveSuccessful");
      }
    },
    clearErrors() {
      this.formErrors.users = [];
    }
  },
  computed: {
    show: {
      get() {
        return !!this.$attrs.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>
